import React, { useState, useEffect } from 'react';

import ApprovalSettingsApprover from './ApprovalSettingsApprover';

import Button from 'CommonComponents/Button';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function ApprovalSettingsItem(props) {
    const [users, setUsers] = useState([]);
    const [availableUsers, setAvailableUsers] = useState([]);
    const [canAddApprover, setCanAddApprover] = useState(true);
    const [errors, setErrors] = useState({});
    const [mounted, setMounted] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [activeError, setActiveError] = useState(false);
    const [showApprovers, setShowApprovers] = useState(false);

    useEffect(() => {
        const usersList = JSON.parse(JSON.stringify(props.usersList));
        setUsers(usersList);

        const err = {};
        props.approversList.forEach((item, index) => {
            err[index] = { user: false, value: false };
        });
        setErrors(err);

        calculateAvailableUsers(props.usersList);
        checkCanAddApprovers();
        setTimeout(() => {
            setMounted(true);
        }, 0);
    }, []);

    useEffect(() => {
        if (props.approversList.length > 0) {
            calculateAvailableUsers(users);
        }
    }, [props.approversList.length]);

    useEffect(() => {
        props.setActiveApproverErrors(activeError);
    }, [activeError]);

    useEffect(() => {
        checkCanAddApprovers();
        checkErrors();
    }, [props.approversList, props.item.type, props.approversList.length]);

    useEffect(() => {
        if (mounted) {
            const isError = checkHasErrors();
            if (isError !== hasError) {
                setHasError(isError);
                props.changeErrors(checkHasErrors());
            }
        }
    }, [errors, props.item.active, props.approversList.length]);

    const checkHasErrors = () => {
        let hasErrors = false;
        if (props.item.active && props.approversList.length === 0) {
            hasErrors = true;
            setActiveError(true);
        } else {
            setActiveError(false);
        }

        Object.keys(errors).forEach((index) => {
            const err = errors[index];
            if (!!err.user || !!err.value) {
                hasErrors = true;
            }
        });

        return hasErrors;
    };

    const checkCanAddApprovers = () => {
        const totalUsers = props.usersList.length;
        const approvers = props.approversList;

        if (totalUsers && approvers.length === 0) {
            setCanAddApprover(true);
            return;
        }

        if (approvers.length >= totalUsers) {
            setCanAddApprover(false);
            return;
        }

        if (props.item.type === 'yes_no') {
            setCanAddApprover(isAllApproversAssigned());
            return;
        }

        setCanAddApprover(isAllApproversAssigned() && isAllApproversValuesAssigned());
    };

    const checkErrors = () => {
        const err = {};
        const approversNumber = props.approversList.length;

        props.approversList.forEach((item, index) => {
            err[index] = { user: false, value: false };
        });

        props.approversList.forEach((approver, index, array) => {
            if (!approver.id) {
                err[index]['user'] = $('This field is required');
            } else {
                err[index]['user'] = false;
            }

            if (props.item.type === 'yes_no') {
                err[index]['value'] = false;
            } else {
                if (index === 0) {
                    if (approversNumber > 1 && approver.id > 0) {
                        const currentValue = approver.value || 0;
                        const nextValue = array[index + 1].value || 0;
                        const nextIsLast = index + 2 === approversNumber;
                        if (nextIsLast) {
                            err[index]['value'] = currentValue > 0 ? false : $t('This value is required and must be less then next value');
                        } else {
                            if (nextValue === 0) {
                                err[index]['value'] = currentValue > 0 ? false : $t('This value is required and must be less then next value');
                            } else {
                                err[index]['value'] = currentValue < nextValue ? false : $t('This value is required and must be less then next value');
                            }
                        }
                    }
                    if (approversNumber === 1) {
                        err[index]['value'] = false;
                    }
                } else {
                    const prevValue = array[index - 1].value || 0;
                    const currentValue = approver.value || 0;
                    const nextValue = array[index + 1] ? array[index + 1].value : 0;
                    const nextIsLast = index + 2 === approversNumber;
                    const currentIsLast = index + 1 === approversNumber;

                    if (currentIsLast) {
                        if (currentValue > 0) {
                            err[index]['value'] = currentValue > prevValue ? false : $t('Value must be more then previous value');
                        } else {
                            err[index]['value'] = false;
                        }
                    } else if (nextIsLast) {
                        if (currentValue > 0) {
                            if (currentValue <= prevValue) {
                                err[index]['value'] = $t('Value must be more then previous value');
                            } else if (currentValue > nextValue && nextValue !== 0) {
                                err[index]['value'] = $t('This value must be less then next value');
                            } else {
                                err[index]['value'] = false;
                            }
                        } else {
                            err[index]['value'] = $t('Value is required and must be more then previous value');
                        }
                    } else {
                        if (currentValue > 0) {
                            if (currentValue <= prevValue) {
                                err[index]['value'] = $t('Value must be more then previous value');
                            } else if (currentValue > nextValue) {
                                err[index]['value'] = $t('This value must be less then next value');
                            } else {
                                err[index]['value'] = false;
                            }
                        } else {
                            err[index]['value'] = $t('Value is required and must be more then previous value');
                        }
                    }
                }
            }
        });

        setErrors(err);
    };

    const isAllApproversAssigned = () => {
        let res = true;

        props.approversList.forEach((approver, index) => {
            if (!approver.id) {
                res = false;
            }
        });

        return res;
    };

    const isAllApproversValuesAssigned = (type) => {
        if (type === 'yes_no') {
            return true;
        }

        let res = true;

        props.approversList.forEach((element, index, array) => {
            if (index === 0) {
                if (!element.value) {
                    res = false;
                }
            } else if (res) {
                const prevValue = array[index - 1].value || 0;
                const currentValue = element.value || 0;
                if (!prevValue || !currentValue || prevValue >= currentValue) {
                    res = false;
                }
            }
        });

        return res;
    };

    const calculateAvailableUsers = (users) => {
        const approverIds = [];
        props.approversList.forEach((approver) => {
            approverIds.push(approver.id);
        });

        const list = users.filter((us) => {
            return !approverIds.includes(us.id);
        });

        setAvailableUsers(list);
    };

    const changeIsActive = (e) => {
        props.changeIsActive(parseInt(e.target.value));
    };

    const changeType = (e) => {
        props.changeType(e.target.value);
    };

    const addApprover = () => {
        props.addApprover({});
        setShowApprovers(true);
    };

    return (
        <div className="table__card tw-space-y-4">
            <div className="tw-text-blue">
                <h3 className="tw-text-xl">
                    {props.item.trigger.trigger === 'Expenditure Approval' ? 'Expenditure Approval and Direct Commitment' : props.item.trigger.trigger}
                </h3>
            </div>
            <div className="form-row">
                <div className="col col-md-4">
                    <div className="tw-flex tw-flex-col tw-space-y-1.5">
                        <label htmlFor={'is-active-' + props.item.id} className="tw-text-charcoal tw-text-sm tw-mb-0">
                            {$t('Active')}
                        </label>
                        <div className={' tw-flex tw-flex-row tw-items-center tw-gap-x-1'}>
                            <select
                                className={'tw-border-0 select-input'}
                                id={'is-active-' + props.item.id}
                                value={props.item.active}
                                onChange={changeIsActive}
                            >
                                <option value={1}>{$t('Yes')}</option>
                                <option value={0}>{$t('No')}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="col col-md-1"></div>
                <div className="col col-md-4">
                    <div className="tw-flex tw-flex-col tw-space-y-1.5">
                        <label htmlFor={'approval-type-' + props.item.id} className="tw-text-charcoal tw-text-sm tw-mb-0">
                            {$t('Approval Type')}
                        </label>
                        <div className={' tw-flex tw-flex-row tw-items-center tw-gap-x-1'}>
                            <select className={'tw-border-0 select-input'} id={'approval-type-' + props.item.id} value={props.item.type} onChange={changeType}>
                                <option value={'yes_no'}>{$t('Yes / No')}</option>
                                {props.item.trigger && props.item.trigger.trigger_code !== 'pr' && <option value={'value'}>{$t('Value')}</option>}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tw-flex tw-flex-row tw-items-center tw-justify-between"></div>
            <div className="row">
                <div
                    className="col col-md-10 text-align-center d-flex align-items-center justify-content-start"
                    onClick={() => setShowApprovers(!showApprovers)}
                >
                    <h5 className="text-blue tw-mr-2">{$t('Approvers')}</h5>
                    {showApprovers ? <ChevronUpIcon className="tw-w-2.5 tw-h-2.5" /> : <ChevronDownIcon className="tw-w-2.5 tw-h-2.5" />}
                </div>
                {!!props.item.active && (
                    <div className="col col-md-2 d-flex align-items-start justify-content-end">
                        <Button small variant="primary" className="px-5 py-3" onClick={addApprover} disabled={!canAddApprover}>
                            <b>{$t('Add approver')}</b>
                        </Button>
                    </div>
                )}
            </div>

            {showApprovers &&
                props.approversList.length > 0 &&
                props.approversList.map((approver, index, arr) => {
                    return (
                        <ApprovalSettingsApprover
                            key={index}
                            type={props.item.type}
                            index={index}
                            prevApprover={index > 0 ? arr[index - 1] : null}
                            approver={approver}
                            availableUsers={availableUsers}
                            changeApprover={props.changeApprover}
                            hasErrors={props.hasErrors}
                            request={props.request}
                            addApprover={addApprover}
                            saveSettings={() => props.saveSettings()}
                            removeApprover={() => props.removeApprover(index)}
                            calculateUsers={() => {
                                calculateAvailableUsers(users);
                            }}
                            users={users}
                            checkCanAddApprovers={checkCanAddApprovers}
                            errors={errors[index]}
                            triggerCode={props.triggerCode}
                        />
                    );
                })}
            {showApprovers && props.approversList.length === 0 && <p>{$t('There are no approvers')}</p>}

            {activeError && (
                <div className={'col-sm-12 text-xs'}>
                    <span className="text-danger">{$t('Must be at least one approver')}</span>
                </div>
            )}
        </div>
    );
}
